<div class="card bg-white border-none max-h-75vh sm:max-h-initial">
  <div class="card-header p-5 sm:p-5 pb-0">
    <div class="flex items-center justify-between">
      <p i18n="Share ad modal" class="flex mb-0 pb-0 text-primaryDark text-lg sm:text-xl font-bold" *ngIf="!title">Dodaj kontakt</p>
      <p class="flex mb-0 pb-0 text-primaryDark text-xl font-bold" *ngIf="title">{{ title }}</p>

      <button (click)="close()" class="btn border-transparent shadow-none text-gray hover:text-grayDark fadeInFadeOut"><i
        class="fas fa-times text-lg"></i></button>
    </div>
  </div>


    <div class="p-3 sm:py-4">
    <div class="text-center">
      <div class="mb-6 text-sm text-grayDark">
        <span i18n>Izberi tip</span>
      </div>

      <div class="flex flex-row flex-wrap justify-evenly mx-auto">
        <button style="min-width: 180px; max-width: 200px; flex-basis: 200px;"
                class="btn py-10 border rounded border-grayTableBorder bg-grayNavi font-bold text-grayDark w-1/4 mx-2 mb-6 flex justify-center shadow-none flex-col items-center"
                (click)="selectType('person')"
                data-test="add-person-button"
                [ngClass]="{'text-primary border-primary bg-primaryWashed': type === 'person'}">

          <div class="text-center text-2xl opacity-85 mb-2">
            <i class="fas fa-user-alt"></i>
          </div>

          <span i18n="Select client type">Fizična oseba</span>
        </button>

        <button style="min-width: 180px; max-width: 200px; flex-basis: 200px;"
                class="btn py-10 border rounded border-grayTableBorder bg-grayNavi font-bold text-grayDark w-1/4 mx-2 mb-6 flex justify-center shadow-none flex-col items-center"
                (click)="selectType('company')"
                data-test="add-legal-entity-button"
                [ngClass]="{'text-primary border-primary bg-primaryWashed': type === 'company'}">

          <div class="text-center text-2xl opacity-85 mb-2">
            <i class="fas fa-building"></i>
          </div>
          <span i18n="Select client type">Pravna oseba</span>
        </button>
      </div>

    </div>
    </div>

  <div class="card-content">


    <div class=" flex flex-row justify-end">
      <button class="btn btn-grayDark-link mr-1" (click)="close()" i18n>Prekliči</button>
      <button class="btn btn-primary ml-1" type="submit" i18n="" (click)="submit()">
        Naprej
      </button>
    </div>
  </div>
</div>

